<template>
    <div class="learning_exam">
        <div class="top_box mar_top_20 flex Flexjustify flexcolumn">
            <div class="filter_box flex">
                <div>学段:</div>
                <div class="flex FlexWrap flex-1">
                    <div class="area_info cursor_pointer"
                        :class="[selectedInfo.stageId == '' ? 'active_area_info' : '']" @click="selectStage('')">
                        不限
                    </div>
                    <div v-for="(item, index) in stageList" :key="index" class="area_info cursor_pointer"
                        :class="[selectedInfo.stageId == item.stageId ? 'active_area_info' : '']"
                        @click="selectStage(item.stageId)">
                        {{ item.stageName }}
                    </div>
                </div>
            </div>
            <div class="filter_box flex">
                <div>年级:</div>
                <div class="flex FlexWrap flex-1">
                    <div class="area_info cursor_pointer"
                        :class="[selectedInfo.gradeId == '' ? 'active_area_info' : '']" @click="selectGrade('')">
                        不限
                    </div>
                    <div v-for="(item, index) in gradeList" :key="index" class="area_info cursor_pointer"
                        :class="[selectedInfo.gradeId == item.gradeId ? 'active_area_info' : '']"
                        @click="selectGrade(item.gradeId)">
                        {{ item.gradeName }}
                    </div>
                </div>
            </div>
            <div class="filter_box flex">
                <div>学科:</div>
                <div class="flex FlexWrap flex-1">
                    <div class="area_info cursor_pointer"
                        :class="[selectedInfo.subjectId == '' ? 'active_area_info' : '']" @click="selectSubjet('')">
                        不限
                    </div>
                    <div v-for="(item, index) in subjectList" :key="index" class="area_info cursor_pointer"
                        :class="[selectedInfo.subjectId == item.subjectId ? 'active_area_info' : '']"
                        @click="selectSubjet(item.subjectId)">
                        {{ item.subjectName }}
                    </div>
                </div>
            </div>
        </div>
        <div class="exam_list" ref="content" :class="{ expanded: isExpanded }">
            <div class="exam_one flex Flexalign" v-for="(item, index) in examList" :key="index">
                <div class="exam_one_left flex Flexalign flexcolumn Flexjustify">
                    <el-image class="stage_exam_img"
                        :src="iconPath(item.chapterType != 4 ? 'stage_exam_img.png' : 'final_exam.png')"></el-image>
                    <div>{{ item.chapterType == 1 ? '章节测试' : (item.chapterType ==
                        2 ? '测验测试' : (item.chapterType == 3 ? '随堂练习' : '结业考试')) }}</div>
                </div>
                <div class="exam_one_right flex flexcolumn FlexBetween mar_left_20 flex-1">
                    <div class="flex Flexalign FlexBetween right_top">
                        <div>{{ item.examName }}</div>
                        <div class="flex Flexalign">
                            <div v-if="item.encouragementWord" class="encouragement_word">{{ item.encouragementWord }}
                            </div>
                            <div class="btn_exam mar_left_20">继续考试</div>
                        </div>
                    </div>
                    <div class="flex Flexalign right_center">
                        <div class="topic_box">题目数量：<span class="exam_topic">{{ item.questionCount }}</span></div>
                        <div class="topic_box">总分：<span class="exam_topic">{{ item.fullScore }}</span></div>
                    </div>
                    <div class="flex Flexalign right_center">
                        <div class="topic_box">对应章节：<span class="exam_topic">{{ item.chapterName }}</span></div>
                        <div class="topic_box">截止时间：<span class="exam_topic">{{ item.deadline }}</span></div>
                    </div>
                    <div class="score_box">
                        <div class="exam_score">{{ item.maxScore || 0 }}</div>
                        <div class="exam_score_text">最终成绩</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="listTotal">
            <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]"
                :total="listTotal" v-model:page-size="selectedInfo.pageSize" @size-change="getMyExamList"
                @current-change="handleCurrentChange" />
        </div>
        <div v-else>
            <moe-empty url="moe_empty_bg_img.png" emptyText="暂无考试记录"></moe-empty>
        </div>
        <!-- <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore" @click="toggleExpand">
            {{ isExpanded ? '收起' : '查看更多记录' }}
            <el-icon v-if="!isExpanded">
                <ArrowDown />
            </el-icon>
            <el-icon v-else>
                <ArrowUp />
            </el-icon>
        </div> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: 'GjkcH5LearningExam',
    computed: {
        ...mapState({
            stageList: (state) => state.filter.stageList,
        }),
    },

    data() {
        return {
            examList: [
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
                // { type: 1, title: '函数与导数的关系', topicNum: 20, totalScore: 100, chapter: '第二章', deadline: '2025/01/20 23:59:00', status: 0, score: 80, encouragementWord: '不要灰心，继续努力！' },
            ],
            isExpanded: false,
            showLoadMore: false,
            gradeList: [],
            subjectList: [],
            selectedInfo: {
                courseId: '',
                chapterId: '',
                stageId: "", // 所属学段ID
                gradeId: "", // 所属年级ID
                subjectId: "", // 所属学科ID
                page: 1, // 页码
                pageSize: 10, // 单页数量
            },
            listTotal: 0
        };
    },
    watch: {
        items: {
            immediate: true,
            handler() {
                this.$nextTick(this.checkOverflow);
            },
        },
    },

    mounted() {
        this.checkOverflow();
        this.gradeList = this.$store.state.filter.gradeList;
        this.subjectList = this.$store.state.filter.subjectList;
        this.getMyExamList();
    },

    methods: {
        // 选择学段
        selectStage(value) {
            this.selectedInfo.stageId = value;
            if (value == "") {
                this.gradeList = this.$store.state.filter.gradeList;
            } else {
                this.gradeList = this.$store.state.filter.gradeList.filter(
                    (item) => item.stageId == value
                );
            }
            this.$Api.common
                .getSubject({ stageId: this.selectedInfo.stageId })
                .then((res) => {
                    this.subjectList = res.data.data;
                    this.getMyExamList();
                })
                .catch((err) => {
                    // this.$Dialog.toast(err.data.message, { type: "error" });
                    console.log(err);
                });
        },
        // 选择年级
        selectGrade(value) {
            this.selectedInfo.gradeId = value;
            this.getMyExamList();
        },
        // 选择学科
        selectSubjet(value) {
            this.selectedInfo.subjectId = value;
            this.getMyExamList();
        },
        checkOverflow() {
            if (!this.$refs.content) return
            this.showLoadMore = this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
        },
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
        },
        handleCurrentChange(value) {
            this.selectedInfo.page = value;
            this.getMyExamList();
        },
        getMyExamList() {
            this.$Api.exam.getMyExamList(this.selectedInfo).then(res => {
                console.log(res.data.data);
                this.examList = res.data.data.list;
                this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
            }).catch(() => { })
        }
    },
};
</script>

<style lang="scss" scoped>
.learning_exam {
    .top_box {
        width: 100%;
        box-sizing: border-box;
        background: #F5F6F8;
        border-radius: 10px;
        padding: 15px;

        .filter_box {
            //   width: $pageMainWidth;
            line-height: 32px;

            // margin-bottom: 10px;
            .area_info {
                padding: 0 11px;
                box-sizing: border-box;
                margin-left: 10px;
            }

            .active_area_info {
                color: #13d6aa;
            }

            .filter {
                width: 95px;
                height: 32px;
                border-radius: 5px;
                border: 1px solid #e1e1e1;
                line-height: 32px;

                .filter_icon {
                    width: 18px;
                    height: 18px;
                }
            }
        }

        .sublist_box {
            margin-top: 10px;

            .opacity_box {
                opacity: 0;
            }

            .area_box {
                margin-left: 10px;
                height: 45px;
                background: #f3f3f3;
                border-radius: 10px;
            }

            .area_info {
                padding: 0 11px;
                box-sizing: border-box;
                margin-left: 10px;
                line-height: 45px;
            }

            .more_box {
                height: 45px;
                margin-right: 10px;
            }

            .filter_icon {
                width: 18px;
                height: 18px;
            }
        }
    }

    .exam_list {
        // max-height: 650px;
        // overflow: hidden;

        .exam_one {
            padding: 20px 0;
            border-bottom: 1px solid rgba(20, 20, 20, 0.1);

            .exam_one_left {
                width: 100px;
                height: 100px;
                background: #F5F6F8;
                border-radius: 10px;
                font-size: 14px;
                color: #999999;

                .stage_exam_img {
                    width: 50px;
                    height: 50px;
                }
            }

            .exam_one_right {
                height: 100px;
                position: relative;

                .right_top {
                    font-weight: bold;
                    font-size: 18px;
                    color: #333333;

                    .encouragement_word {
                        color: #999999;
                        font-weight: 400;
                        font-size: 16px;
                    }

                    .btn_exam {
                        width: 79px;
                        height: 34px;
                        background: linear-gradient(90deg, #00D5C2, #00D498);
                        border-radius: 17px;
                        color: #ffffff;
                        line-height: 34px;
                        text-align: center;
                        font-weight: 400;
                        font-size: 16px;
                    }
                }

                .right_center {
                    font-size: 16px;
                    color: #666666;

                    .topic_box {
                        width: 40%;
                        text-align: start;
                    }

                    .exam_topic {
                        font-weight: 500;
                        font-size: 18px;
                        color: #333333;
                    }
                }

                .score_box {
                    position: absolute;
                    text-align: center;
                    right: 0;
                    top: 36px;

                    .exam_score {
                        font-weight: 500;
                        font-size: 32px;
                        color: #13D6AA;
                    }

                    .exam_score_text {
                        font-size: 14px;
                        color: #666666;
                    }
                }
            }
        }
    }

    .exam_list.expanded {
        max-height: none;
        overflow: visible;
        /* 展开后高度 */
    }

    .more_load {
        width: 200px;
        height: 35px;
        background: #F5F6F8;
        border-radius: 8px;
        line-height: 35px;
        text-align: center;
        margin: 10px auto;
    }
}
</style>